export const RESORT_RESORT = 'RESORT'
export const RESORT_HOLIDAYPARK = 'HOLIDAYPARK'
